import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
    Row,
    Col,
    H4,
} from '@bootstrap-styled/v4';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

import {
    Wysiwyg,
    ToolNav,
    ToolNavButton,
    ToolMiscButton,
} from '../../theme/components';

import decodeHTML from '../../services/content/decode-html';
import getProductContent from '../../services/content/get-product-content';
import getProductContentItems from '../../services/content/get-product-content-items';
import ComposeReportEditor from '../compose-report-editor/container';

import Style from './style';

const ComposeReportTool = ({
    selectproduct,
    selectedsections,
    copytoclipboardrequested,
    addSection,
    addAllSections,
    removeAllSections,
    removeSection,
    copyToClipboard,
    content,
}) => (
    <Style>
        <Row>
            <Col xs="12" lg="3">
                <div className={`tool-nav ${selectproduct && selectproduct.product && selectproduct.product.length > 0 ? '' : 'tool-nav-disabled'}`}>
                    {
                        selectproduct && selectproduct.product && selectproduct.product.length > 0 && (
                            <>
                                <ToolNav>
                                    <li>
                                        {getProductContentItems(selectproduct, content.reasonswhy).length === selectedsections.length ? (
                                            <ToolNavButton className="active" onClick={() => removeAllSections()}>
                                                SELECT ALL
                                                <span className="icon" />
                                            </ToolNavButton>

                                        ) : (
                                            <ToolNavButton onClick={() => addAllSections()}>
                                                SELECT ALL
                                                <span className="icon" />
                                            </ToolNavButton>

                                        )}
                                    </li>
                                </ToolNav>
                                <div>
                                    {
                                        getProductContent(selectproduct, content.reasonswhy).map((category) => (
                                            <div key={category.slug}>
                                                <H4>{category.name}</H4>
                                                <ToolNav>
                                                    {
                                                        category.items.map((item) => (
                                                            <li key={item.slug}>
                                                                {selectedsections.filter((i) => i.slug === item.slug).length > 0 ? (
                                                                    <ToolNavButton className="active" onClick={() => removeSection(item.slug)}>
                                                                        { ReactHtmlParser(decodeHTML(item.title), { decodeEntities: true }) }
                                                                        <span className="icon" />
                                                                    </ToolNavButton>
                                                                ) : (
                                                                    <ToolNavButton onClick={() => addSection(item.slug)}>
                                                                        { ReactHtmlParser(decodeHTML(item.title), { decodeEntities: true }) }
                                                                        <span className="icon" />
                                                                    </ToolNavButton>
                                                                )}
                                                            </li>
                                                        ))
                                                    }
                                                </ToolNav>
                                            </div>

                                        ))
                                    }
                                </div>
                            </>
                        )
                    }
                </div>
            </Col>
            <Col xs="12" lg="9">
                <div className={`tool-body ${selectproduct && selectproduct.product && selectproduct.product.length > 0 ? '' : 'tool-body-disabled'}`}>
                    {content && content.intro && (
                        <>
                            {selectedsections.length === 0 ? (
                                <div className="tool-body-disclaimer">
                                    <Wysiwyg>
                                        <div>{ ReactHtmlParser(decodeHTML(content.intro), { decodeEntities: true }) }</div>
                                    </Wysiwyg>
                                </div>
                            ) : (
                                selectedsections.map((item) => (
                                    <ComposeReportEditor key={item.slug} section={item} />
                                ))
                            )}
                        </>
                    )}
                </div>
                {content && content.intro && (
                    <Row>
                        <Col xs="12" md={{ offset: 8, size: 4 }}>
                            <Row>
                                <Col xs="12" className="mb-3">
                                    {copytoclipboardrequested ? (
                                        <>
                                            <ToolMiscButton disabled={!selectedsections.length || copytoclipboardrequested} className="copy-btn" onClick={() => copyToClipboard()}>
                                                Copy paragraphs
                                                <span className="icon-container">
                                                    <FontAwesomeIcon icon={faSync} />
                                                </span>
                                            </ToolMiscButton>

                                        </>
                                    ) : (
                                        <>
                                            <ToolMiscButton disabled={!selectedsections.length || copytoclipboardrequested} className="copy-btn" onClick={() => copyToClipboard()}>
                                                Copy paragraphs
                                                <span className="icon" />
                                            </ToolMiscButton>

                                        </>
                                    )}
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    </Style>

);

ComposeReportTool.propTypes = {
    copytoclipboardrequested: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    selectedsections: PropTypes.array,
    // eslint-disable-next-line react/forbid-prop-types
    selectproduct: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    content: PropTypes.object,
    addSection: PropTypes.func,
    addAllSections: PropTypes.func,
    removeAllSections: PropTypes.func,
    removeSection: PropTypes.func,
    copyToClipboard: PropTypes.func,
    // clearClipboard: PropTypes.func,
};

ComposeReportTool.defaultProps = {
    selectproduct: {},
    content: {},
    copytoclipboardrequested: false,
    selectedsections: [],
    addSection: () => {},
    addAllSections: () => {},
    removeAllSections: () => {},
    removeSection: () => {},
    copyToClipboard: () => {},
    // clearClipboard: () => {},
};
export default ComposeReportTool;
